export const TYPES = {
  LoginUseCases: Symbol.for('LoginUseCases'),
  LoginRepository: Symbol.for('LoginRepository'),
};
